/* globals Plaid */
import { includeScript } from '../../includeHelper';
import pseudoClassElemStyleHelper from '../../../helpers/pseudoClassElemStyleHelper';

const linkScript = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';
let context = {};
let plaidHandler;
const plaidLink = document.createElement('a');
const plaidLinkId = 'maxio-js-plaid-link';
let directDebitDataConfirmed = false;

const init = (ctx) => {
  context = ctx;
};

const plaidLinkElem = () => {
  if (!context.globalUserOptions) return;

  return document.querySelector(`${context.globalUserOptions.selectorForPlaidLink}`);
};

const includePlaidScript = async () => {
  if (document.querySelector(`script[src="${linkScript}"]`)) return;

  await includeScript(linkScript);
};

const createIframes = () => context.createIframes();

const createPlaidLink = () => {
  if (document.querySelector(`#${plaidLinkId}`)) return;

  const plaidLinkName = context.globalUserOptions.plaidLinkName || 'Use Plaid to connect my bank account';

  plaidLink.title = plaidLinkName;
  plaidLink.href = '#';
  plaidLink.id = plaidLinkId;

  const linkName = document.createTextNode(plaidLinkName);
  plaidLink.appendChild(linkName);

  assignCustomStylesForPlaidLink();
  plaidLinkElem().appendChild(plaidLink);
};

const assignCustomStylesForPlaidLink = () => {
  Object.keys(context.globalUserOptions.plaidLinkStyle || {}).forEach((eachStyle) => {
    if (pseudoClassElemStyleHelper.isPseudoClassOrElem(eachStyle)) {
      const cssStyleText = pseudoClassElemStyleHelper.cssStyleTextForElement(
        plaidLink,
        eachStyle,
        context.globalUserOptions.plaidLinkStyle[eachStyle]
      );
      pseudoClassElemStyleHelper.addCssStyleTextToPage(cssStyleText);
    } else {
      plaidLink.style[eachStyle] = context.globalUserOptions.plaidLinkStyle[eachStyle];
    }
  });
};

const showPlaidLinkButton = () => {
  plaidLinkElem().style.display = 'block';
};

const hidePlaidLinkButton = () => {
  plaidLinkElem().style.display = 'none';
};

const maskBankAccountsForOptions = (accounts) =>
  accounts.map(account => {
      return ({
        text: `*** *** ${account.mask}`,
        value: `${account.subtype}|${account.id}`
      });
    });

const setOptionsForSelectField = (options) => {
  const message = {
    action: 'SET_OPTIONS_FOR_SELECT_FIELD',
    data: {
      name: 'bankAccount',
      options
    }
  };

  context.sendMessageToAllFields(message);
};

const initPlaidLink = (linkToken, oneTimeToken = null) => {
  plaidHandler = Plaid.create({
    token: linkToken,
    onSuccess: (publicToken, metadata) => {
      let bankName = metadata.institution.name || '';
      let pending = '';
      let mask = '';

      if (metadata.account.verification_status === 'pending_manual_verification') {
        pending = '1';
        mask = metadata.account.mask;
      }
      if (metadata.account.verification_status === 'manually_verified') {
        const message = {
          action: 'PLAID_VERIFY_ACCOUNT',
          data: {
            publicToken: publicToken,
            linkSessionId: metadata.link_session_id,
            accountId: metadata.account.id,
            bankName: bankName,
            oneTimeToken: oneTimeToken }
        }
        context.sendMessageToMainIframe(message);
      } else {
        const message = {
          action: 'PLAID_SET_ADDITIONAL_FIELDS',
          data: { publicToken: publicToken, linkSessionId: metadata.link_session_id, pending: pending, bankName: bankName, maskedBankAccountNumber: mask }
        }
        context.sendMessageToMainIframe(message);
        context.globalCallbacks.onPlaidComplete();
        setOptionsForSelectField(maskBankAccountsForOptions(metadata.accounts));
      }
      hidePlaidLinkButton();
    },
    onExit: (error) => {
      context.globalCallbacks.onPlaidExit(error ? error.error_message : null);
    },
    onLoad: () => {
      createPlaidLink();
      showPlaidLinkButton();
      plaidLink.addEventListener('click', clickPlaidLink);
    }
  });
};

const clickPlaidLink = () => plaidHandler.open();

const unload = () => {
  if (!plaidLinkElem()) return;

  hidePlaidLinkButton();
};

const setDirectDebitDataConfirmed = (value) => { directDebitDataConfirmed = value; };
const directDebitDataNotConfirmed = () => !directDebitDataConfirmed;

export default {
  init,
  includePlaidScript,
  createIframes,
  initPlaidLink,
  unload,
  setDirectDebitDataConfirmed,
  directDebitDataNotConfirmed
};
